<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :title="sshKey ? sshKey.name : ''"
    :before-close="onClose"
    width="700px"
    center
  >
    <div v-if="sshKey" class="key-details">
      <div class="key-section">
        <label>{{ $t('SshKeyManagement_Label_Fingerprint') }}</label>
        <div class="key-value">{{ sshKey.public_key_fingerprint }}</div>
      </div>
      <div class="key-section">
        <label>{{ $t('SshKeyManagement_Label_Type') }}</label>
        <div class="key-value">{{ getKeyTypeLabel(sshKey.key_type) }}</div>
      </div>
      <div class="key-section">
        <label>{{ $t('SshKeyManagement_Label_PublicKey_OpenSSH') }}</label>
        <div class="key-copy-container">
          <el-input
            type="textarea"
            :rows="4"
            :value="sshKey.public_key_openssh"
            readonly
          />
          <el-button
            type="text"
            class="copy-button"
            icon="el-icon-copy-document"
            @click="copyKey(sshKey.public_key_openssh)"
          />
        </div>
      </div>
      <div class="key-section">
        <label>{{ $t('SshKeyManagement_Label_PublicKey_PKCS8') }}</label>
        <div class="key-copy-container">
          <el-input
            type="textarea"
            :rows="6"
            :value="sshKey.public_key"
            readonly
          />
          <el-button
            type="text"
            class="copy-button"
            icon="el-icon-copy-document"
            @click="copyKey(sshKey.public_key)"
          />
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onClose">
        {{ $t('Button_Close') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import sshKeyTypesMixin from '@/common/mixins/sshKeyTypesMixin'

/**
 * SSH Key View Dialog Component
 * Displays SSH key details with copy functionality
 */
export default {
  name: 'SshKeyViewDialog',

  mixins: [sshKeyTypesMixin],

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sshKey: {
      type: Object,
      default: null
    }
  },

  mounted() {
    this.fetchKeyTypes()
  },

  methods: {
    copyKey(key) {
      navigator.clipboard.writeText(key).then(() => {
        this.$message({
          message: this.$t('SshKeyManagement_Message_Copied'),
          type: 'success'
        })
      })
    },

    onClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.key-details {
  padding: 0 20px;
}

.key-section {
  margin-bottom: 20px;
}

.key-section label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #606266;
}

.key-value {
  font-family: monospace;
  background: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
  word-break: break-all;
}

.key-copy-container {
  position: relative;
}

.copy-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 18px;
  z-index: 1;
}

>>> .key-copy-container textarea {
  font-family: monospace;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ssh/SshKeyViewDialog.vue